// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChannelMargin_pageWrap__LyRTl {
  padding: 4px 4px 32px;
}

.ChannelMargin_desktopTable__fUs3l {
  display: block;
}

.ChannelMargin_mobileList__Yf380 {
  display: none;
}

@media (max-width: 767px) {
  .ChannelMargin_desktopTable__fUs3l {
    display: none;
  }
  .ChannelMargin_mobileList__Yf380 {
    display: block;
  }
}

/* =========================================================
   Status pills
   ========================================================= */
.ChannelMargin_pillBase__XAfVf {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  text-transform: capitalize;
}
.ChannelMargin_pillViolet__YaiuB { background: #F5F3FE; color: #4c2fb3; }
.ChannelMargin_pillBlue__qmpsk { background: #EAF2FE; color: #3B82F6; }
.ChannelMargin_pillGreen__PLqT8 { background: #E7F8EF; color: #12B76A; }
.ChannelMargin_pillAmber__RNlSh { background: #FDEEDD; color: #F7941D; }
.ChannelMargin_pillGrey__PZRys { background: #F3F4F6; color: #6B7280; }

.ChannelMargin_actionCell__0ErqB {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ChannelMargin_emptyState__PoSkn {
  text-align: center;
  color: #9CA3AF;
  font-size: 13.5px;
  padding: 40px 0;
}

/* =========================================================
   Mobile card list
   ========================================================= */
.ChannelMargin_mobileCard__qqU4V {
  border: 1px solid #EEF0F6;
  border-radius: 14px;
  background: #ffffff;
  padding: 16px;
  margin-bottom: 12px;
}

.ChannelMargin_mobileRow__TCZ7\\+ {
  display: flex;
  gap: 12px;
  padding: 4px 0;
  font-size: 13px;
}

.ChannelMargin_mobileLabel__O9i97 {
  min-width: 110px;
  flex-shrink: 0;
  color: #6B7280;
  font-weight: 600;
}

.ChannelMargin_mobileValue__jDeuo {
  color: #1F2430;
}

.ChannelMargin_mobileActionRow__65zzG {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

/* =========================================================
   Form
   ========================================================= */
.ChannelMargin_sectionTitle__1XVbr {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #4c2fb3;
  margin: 26px 0 14px;
  padding-top: 14px;
  border-top: 1px solid #EEF0F6;
}
.ChannelMargin_sectionTitle__1XVbr:first-child {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}

.ChannelMargin_sectionHint__ToLD7 {
  font-size: 12px;
  color: #9CA3AF;
  margin: -8px 0 14px;
}

.ChannelMargin_submitRow__mkk-n {
  margin-top: 8px;
}

/* Light violet-themed polish for antd Select's default markup */
.ChannelMargin_field__iX7X8 .ant-select .ant-select-selector {
  border: 1px solid #E5E7EB !important;
  border-radius: 10px !important;
  padding: 4px 10px !important;
  min-height: 42px;
  display: flex;
  align-items: center;
}
.ChannelMargin_field__iX7X8 .ant-select-focused .ant-select-selector {
  border-color: #4c2fb3 !important;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15) !important;
}
.ChannelMargin_field__iX7X8 .ant-select-dropdown {
  border-radius: 10px !important;
  box-shadow: 0 12px 28px rgba(27, 37, 89, 0.12) !important;
}
.ChannelMargin_field__iX7X8 .ant-select-item-option-selected {
  background: #F5F3FE !important;
  color: #4c2fb3 !important;
  font-weight: 600 !important;
}
.ChannelMargin_field__iX7X8 .ant-select-item-option-active {
  background: #FAF8FF !important;
}

/* =========================================================
   Bulk grid (redesigned create)
   ========================================================= */
.ChannelMargin_scopeTabs__J7qRu {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 18px;
}
.ChannelMargin_scopeTab__m06fj {
  padding: 8px 18px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  background: #fff;
  font-size: 13px;
  font-weight: 600;
  color: #6B7280;
  cursor: pointer;
  transition: all 0.15s ease;
}
.ChannelMargin_scopeTab__m06fj:hover {
  border-color: #4c2fb3;
  color: #4c2fb3;
}
.ChannelMargin_scopeTabActive__5vIea,
.ChannelMargin_scopeTabActive__5vIea:hover {
  background: #4c2fb3;
  border-color: #4c2fb3;
  color: #fff;
}

.ChannelMargin_contextRow__2w86x {
  margin-bottom: 4px;
}

.ChannelMargin_bulkApplyBar__oQwOH {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  padding: 14px;
  background: #FAF8FF;
  border: 1px solid #EEE9FF;
  border-radius: 12px;
  margin: 6px 0 14px;
}
.ChannelMargin_bulkApplyField__Memvw {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ChannelMargin_bulkApplyLabel__UOz2\\+ {
  font-size: 11px;
  font-weight: 700;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.ChannelMargin_applyAllBtn__qM1-k {
  padding: 9px 16px;
  border-radius: 9px;
  border: none;
  background: #4c2fb3;
  color: #fff;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
}
.ChannelMargin_applyAllBtn__qM1-k:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.ChannelMargin_clearAllBtn__YZB5n {
  padding: 9px 16px;
  border-radius: 9px;
  border: 1px solid #E5E7EB;
  background: #fff;
  color: #6B7280;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
}

.ChannelMargin_gridToolbar__\\+Nw0g {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}
.ChannelMargin_gridSearch__wa6AV {
  width: 260px;
  max-width: 100%;
  padding: 9px 12px;
  border: 1px solid #E5E7EB;
  border-radius: 9px;
  font-size: 13px;
}
.ChannelMargin_gridSearch__wa6AV:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}
.ChannelMargin_rowCountHint__1DhQo {
  font-size: 12.5px;
  color: #6B7280;
  font-weight: 600;
}
.ChannelMargin_rowCountHint__1DhQo b {
  color: #4c2fb3;
}

.ChannelMargin_gridScroll__8vLEo {
  max-height: 52vh;
  overflow: auto;
  border: 1px solid #EEF0F6;
  border-radius: 12px;
}
.ChannelMargin_marginGrid__PuakS {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.ChannelMargin_marginGrid__PuakS thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #F7F7FB;
  text-align: left;
  padding: 10px 14px;
  font-size: 11px;
  font-weight: 700;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  border-bottom: 1px solid #EEF0F6;
}
.ChannelMargin_marginGrid__PuakS tbody td {
  padding: 8px 14px;
  border-bottom: 1px solid #F3F4F6;
  vertical-align: middle;
}
.ChannelMargin_marginGrid__PuakS tbody tr:hover {
  background: #FAFAFE;
}
.ChannelMargin_marginGrid__PuakS tbody tr.ChannelMargin_rowActive__GvMgj {
  background: #F5F3FE;
}
.ChannelMargin_gridNameCell__-Bo2c {
  font-weight: 600;
  color: #1F2430;
}
.ChannelMargin_gridSubtle__Vnsfn {
  color: #9CA3AF;
  font-weight: 500;
  font-size: 12px;
  margin-top: 2px;
}
.ChannelMargin_miniSelect__7-LrA,
.ChannelMargin_miniInput__-gL9H {
  width: 100%;
  max-width: 150px;
  padding: 7px 10px;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  font-size: 12.5px;
}
.ChannelMargin_miniInput__-gL9H:focus,
.ChannelMargin_miniSelect__7-LrA:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}
.ChannelMargin_gridEmpty__QVZID {
  text-align: center;
  color: #9CA3AF;
  font-size: 13px;
  padding: 36px 0;
}

@media (max-width: 767px) {
  .ChannelMargin_miniSelect__7-LrA,
  .ChannelMargin_miniInput__-gL9H {
    max-width: none;
  }
  .ChannelMargin_gridSearch__wa6AV {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/channelMargin/ChannelMargin.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;;8DAE8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA,mCAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,iCAAY,mBAAmB,EAAE,cAAc,EAAE;AACjD,kCAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,kCAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,iCAAY,mBAAmB,EAAE,cAAc,EAAE;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;8DAE8D;AAC9D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;8DAE8D;AAC9D;EACE,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,gEAAgE;AAChE;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,yDAAyD;AAC3D;AACA;EACE,8BAA8B;EAC9B,yDAAyD;AAC3D;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,8BAA8B;AAChC;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n.desktopTable {\n  display: block;\n}\n\n.mobileList {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .desktopTable {\n    display: none;\n  }\n  .mobileList {\n    display: block;\n  }\n}\n\n/* =========================================================\n   Status pills\n   ========================================================= */\n.pillBase {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n  text-transform: capitalize;\n}\n.pillViolet { background: #F5F3FE; color: #4c2fb3; }\n.pillBlue { background: #EAF2FE; color: #3B82F6; }\n.pillGreen { background: #E7F8EF; color: #12B76A; }\n.pillAmber { background: #FDEEDD; color: #F7941D; }\n.pillGrey { background: #F3F4F6; color: #6B7280; }\n\n.actionCell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.emptyState {\n  text-align: center;\n  color: #9CA3AF;\n  font-size: 13.5px;\n  padding: 40px 0;\n}\n\n/* =========================================================\n   Mobile card list\n   ========================================================= */\n.mobileCard {\n  border: 1px solid #EEF0F6;\n  border-radius: 14px;\n  background: #ffffff;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.mobileRow {\n  display: flex;\n  gap: 12px;\n  padding: 4px 0;\n  font-size: 13px;\n}\n\n.mobileLabel {\n  min-width: 110px;\n  flex-shrink: 0;\n  color: #6B7280;\n  font-weight: 600;\n}\n\n.mobileValue {\n  color: #1F2430;\n}\n\n.mobileActionRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n/* =========================================================\n   Form\n   ========================================================= */\n.sectionTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  color: #4c2fb3;\n  margin: 26px 0 14px;\n  padding-top: 14px;\n  border-top: 1px solid #EEF0F6;\n}\n.sectionTitle:first-child {\n  margin-top: 0;\n  padding-top: 0;\n  border-top: none;\n}\n\n.sectionHint {\n  font-size: 12px;\n  color: #9CA3AF;\n  margin: -8px 0 14px;\n}\n\n.submitRow {\n  margin-top: 8px;\n}\n\n/* Light violet-themed polish for antd Select's default markup */\n.field :global(.ant-select .ant-select-selector) {\n  border: 1px solid #E5E7EB !important;\n  border-radius: 10px !important;\n  padding: 4px 10px !important;\n  min-height: 42px;\n  display: flex;\n  align-items: center;\n}\n.field :global(.ant-select-focused .ant-select-selector) {\n  border-color: #4c2fb3 !important;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15) !important;\n}\n.field :global(.ant-select-dropdown) {\n  border-radius: 10px !important;\n  box-shadow: 0 12px 28px rgba(27, 37, 89, 0.12) !important;\n}\n.field :global(.ant-select-item-option-selected) {\n  background: #F5F3FE !important;\n  color: #4c2fb3 !important;\n  font-weight: 600 !important;\n}\n.field :global(.ant-select-item-option-active) {\n  background: #FAF8FF !important;\n}\n\n/* =========================================================\n   Bulk grid (redesigned create)\n   ========================================================= */\n.scopeTabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 18px;\n}\n.scopeTab {\n  padding: 8px 18px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  background: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  color: #6B7280;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n.scopeTab:hover {\n  border-color: #4c2fb3;\n  color: #4c2fb3;\n}\n.scopeTabActive,\n.scopeTabActive:hover {\n  background: #4c2fb3;\n  border-color: #4c2fb3;\n  color: #fff;\n}\n\n.contextRow {\n  margin-bottom: 4px;\n}\n\n.bulkApplyBar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 12px;\n  padding: 14px;\n  background: #FAF8FF;\n  border: 1px solid #EEE9FF;\n  border-radius: 12px;\n  margin: 6px 0 14px;\n}\n.bulkApplyField {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.bulkApplyLabel {\n  font-size: 11px;\n  font-weight: 700;\n  color: #6B7280;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n.applyAllBtn {\n  padding: 9px 16px;\n  border-radius: 9px;\n  border: none;\n  background: #4c2fb3;\n  color: #fff;\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.applyAllBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.clearAllBtn {\n  padding: 9px 16px;\n  border-radius: 9px;\n  border: 1px solid #E5E7EB;\n  background: #fff;\n  color: #6B7280;\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.gridToolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n.gridSearch {\n  width: 260px;\n  max-width: 100%;\n  padding: 9px 12px;\n  border: 1px solid #E5E7EB;\n  border-radius: 9px;\n  font-size: 13px;\n}\n.gridSearch:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n.rowCountHint {\n  font-size: 12.5px;\n  color: #6B7280;\n  font-weight: 600;\n}\n.rowCountHint b {\n  color: #4c2fb3;\n}\n\n.gridScroll {\n  max-height: 52vh;\n  overflow: auto;\n  border: 1px solid #EEF0F6;\n  border-radius: 12px;\n}\n.marginGrid {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n.marginGrid thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #F7F7FB;\n  text-align: left;\n  padding: 10px 14px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #6B7280;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  border-bottom: 1px solid #EEF0F6;\n}\n.marginGrid tbody td {\n  padding: 8px 14px;\n  border-bottom: 1px solid #F3F4F6;\n  vertical-align: middle;\n}\n.marginGrid tbody tr:hover {\n  background: #FAFAFE;\n}\n.marginGrid tbody tr.rowActive {\n  background: #F5F3FE;\n}\n.gridNameCell {\n  font-weight: 600;\n  color: #1F2430;\n}\n.gridSubtle {\n  color: #9CA3AF;\n  font-weight: 500;\n  font-size: 12px;\n  margin-top: 2px;\n}\n.miniSelect,\n.miniInput {\n  width: 100%;\n  max-width: 150px;\n  padding: 7px 10px;\n  border: 1px solid #E5E7EB;\n  border-radius: 8px;\n  font-size: 12.5px;\n}\n.miniInput:focus,\n.miniSelect:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n.gridEmpty {\n  text-align: center;\n  color: #9CA3AF;\n  font-size: 13px;\n  padding: 36px 0;\n}\n\n@media (max-width: 767px) {\n  .miniSelect,\n  .miniInput {\n    max-width: none;\n  }\n  .gridSearch {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `ChannelMargin_pageWrap__LyRTl`,
	"desktopTable": `ChannelMargin_desktopTable__fUs3l`,
	"mobileList": `ChannelMargin_mobileList__Yf380`,
	"pillBase": `ChannelMargin_pillBase__XAfVf`,
	"pillViolet": `ChannelMargin_pillViolet__YaiuB`,
	"pillBlue": `ChannelMargin_pillBlue__qmpsk`,
	"pillGreen": `ChannelMargin_pillGreen__PLqT8`,
	"pillAmber": `ChannelMargin_pillAmber__RNlSh`,
	"pillGrey": `ChannelMargin_pillGrey__PZRys`,
	"actionCell": `ChannelMargin_actionCell__0ErqB`,
	"emptyState": `ChannelMargin_emptyState__PoSkn`,
	"mobileCard": `ChannelMargin_mobileCard__qqU4V`,
	"mobileRow": `ChannelMargin_mobileRow__TCZ7+`,
	"mobileLabel": `ChannelMargin_mobileLabel__O9i97`,
	"mobileValue": `ChannelMargin_mobileValue__jDeuo`,
	"mobileActionRow": `ChannelMargin_mobileActionRow__65zzG`,
	"sectionTitle": `ChannelMargin_sectionTitle__1XVbr`,
	"sectionHint": `ChannelMargin_sectionHint__ToLD7`,
	"submitRow": `ChannelMargin_submitRow__mkk-n`,
	"field": `ChannelMargin_field__iX7X8`,
	"scopeTabs": `ChannelMargin_scopeTabs__J7qRu`,
	"scopeTab": `ChannelMargin_scopeTab__m06fj`,
	"scopeTabActive": `ChannelMargin_scopeTabActive__5vIea`,
	"contextRow": `ChannelMargin_contextRow__2w86x`,
	"bulkApplyBar": `ChannelMargin_bulkApplyBar__oQwOH`,
	"bulkApplyField": `ChannelMargin_bulkApplyField__Memvw`,
	"bulkApplyLabel": `ChannelMargin_bulkApplyLabel__UOz2+`,
	"applyAllBtn": `ChannelMargin_applyAllBtn__qM1-k`,
	"clearAllBtn": `ChannelMargin_clearAllBtn__YZB5n`,
	"gridToolbar": `ChannelMargin_gridToolbar__+Nw0g`,
	"gridSearch": `ChannelMargin_gridSearch__wa6AV`,
	"rowCountHint": `ChannelMargin_rowCountHint__1DhQo`,
	"gridScroll": `ChannelMargin_gridScroll__8vLEo`,
	"marginGrid": `ChannelMargin_marginGrid__PuakS`,
	"rowActive": `ChannelMargin_rowActive__GvMgj`,
	"gridNameCell": `ChannelMargin_gridNameCell__-Bo2c`,
	"gridSubtle": `ChannelMargin_gridSubtle__Vnsfn`,
	"miniSelect": `ChannelMargin_miniSelect__7-LrA`,
	"miniInput": `ChannelMargin_miniInput__-gL9H`,
	"gridEmpty": `ChannelMargin_gridEmpty__QVZID`
};
export default ___CSS_LOADER_EXPORT___;
